import * as React from 'react';
import classNames from 'classnames';
import {Button, Section, Flex} from 'components/UIKit';
import {Category} from 'interfaces';
import {CategoryCard} from '../CategoryCard';
import styles from './CategoryCardLayout.scss';

export interface CategoryCardLayoutProps {
  heading: string;
  subhead?: string;
  categories: Category[];
  className?: string;
  ctaPath?: string;
  cta?: string;
}

export function CategoryCardLayout({
  heading,
  subhead,
  categories,
  className,
  ctaPath,
  cta,
}: CategoryCardLayoutProps) {
  const desktopCardWidth =
    categories.length % 4 === 0 || categories.length > 15 ? 'DesktopQuarters' : 'DesktopThirds';
  const tabletCardWidth = categories.length % 3 === 0 ? 'TabletThirds' : 'TabletHalves';
  const showCta = Boolean(ctaPath) && Boolean(cta);

  return (
    <Section
      heading={heading}
      subhead={subhead}
      headingProps={{align: 'center'}}
      subheadProps={{align: 'center'}}
      className={className}
      headerSpacing="medium"
    >
      <div
        className={classNames(
          styles.Categories,
          styles[desktopCardWidth],
          styles[tabletCardWidth],
          {[styles.Spacing]: showCta},
        )}
      >
        {categories.map((location) => (
          <CategoryCard
            key={location.handle}
            path={location.path}
            title={location.title}
            className={styles.Card}
            imageUrl={location.imageUrl}
            listingCount={location.listingCount}
          />
        ))}
      </div>
      {showCta && (
        <Flex justifyContent="center">
          <Button label={cta} url={ctaPath} secondary />
        </Flex>
      )}
    </Section>
  );
}
